export const TEAMS = [
  { key: "sales", label: "Sales", individual: true },
  { key: "service", label: "Service", individual: true },
  { key: "bulk_procurement", label: "Bulk Procurement", individual: false },
  { key: "dealership_bd", label: "Dealership / BD", individual: false },
  { key: "csr", label: "CSR / Corporate Affairs", individual: false },
  { key: "warranty", label: "Warranty / After-Sales", individual: false },
];

export const ROLES = [
  { key: "admin", label: "Admin (sees all)" },
  { key: "team_lead", label: "Team Lead (all team records)" },
  { key: "team_member", label: "Team Member (assigned records)" },
  { key: "sales_agent", label: "Sales Agent (own registrations only)" },
  { key: "sales_incentive", label: "Sales Incentives (approves agent incentives)" },
];

export const REQUEST_TYPES = {
  contact_us_lead: { label: "New Product Lead", color: "lead", team: "sales" },
  contact_us_complaint: { label: "Complaint / Service Issue", color: "complaint", team: "service" },
  contact_us_general: { label: "General Enquiry", color: "general", team: "sales" },
  contact_us_feedback: { label: "Suggestion / Feedback", color: "feedback", team: "sales" },
  bulk_procurement: { label: "Bulk Procurement", color: "bulk", team: "bulk_procurement" },
  warranty: { label: "Product Registration", color: "warranty", team: "warranty" },
  dealership: { label: "Dealer Application", color: "dealership", team: "dealership_bd" },
  csr: { label: "CSR Connect", color: "csr", team: "csr" },
};

export const STATUS_STYLES = {
  lead: { bg: "#F3E8FF", text: "#6B21A8", border: "#D8B4FE" },
  complaint: { bg: "#FEE2E2", text: "#991B1B", border: "#FCA5A5" },
  general: { bg: "#F1F5F9", text: "#334155", border: "#CBD5E1" },
  feedback: { bg: "#FEF3C7", text: "#92400E", border: "#FCD34D" },
  bulk: { bg: "#FFEDD5", text: "#C2410C", border: "#FDBA74" },
  warranty: { bg: "#DBEAFE", text: "#1D4ED8", border: "#93C5FD" },
  csr: { bg: "#DCFCE7", text: "#15803D", border: "#86EFAC" },
  dealership: { bg: "#FEF9C3", text: "#A16207", border: "#FDE047" },
};

export const INSTITUTION_TYPES = [
  "Hospital",
  "Nursing Home",
  "Rehab Centre",
  "Government Tender",
  "Distributor",
  "Corporate CSR",
  "Other",
];

export const PARTNERSHIP_TYPES = [
  "Equipment Donation",
  "Funding Support",
  "Awareness Drive",
  "Distribution Partnership",
  "Other",
];

export const BUSINESS_TYPES = [
  "Medical Equipment Store",
  "Pharmacy",
  "General Trading",
  "New Business",
  "Other",
];

export const INVESTMENT_RANGES = [
  "< ₹2 lakh",
  "₹2 – 5 lakh",
  "₹5 – 10 lakh",
  "₹10 – 25 lakh",
  "> ₹25 lakh",
];

export const BUDGET_RANGES = [
  "< ₹10,000",
  "₹10,000 – ₹25,000",
  "₹25,000 – ₹50,000",
  "₹50,000 – ₹1,00,000",
  "> ₹1,00,000",
];

// Manual-entry schemas (used inside CRM by staff). Public forms live in HandoffPage.
export const MANUAL_FORM_SCHEMAS = {
  contact_us_lead: {
    label: "New Product Lead",
    fields: [
      { key: "full_name", label: "Full Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "product_category_interest", label: "Product Category Interested In", type: "text", placeholder: "e.g., Wheelchairs, Hospital Beds, Walkers, Mattresses" },
      { key: "budget", label: "Preferred Budget", type: "select", options: BUDGET_RANGES },
      { key: "message", label: "Message / Details", type: "textarea", required: true },
    ],
    hidden: { enquiry_type: "Looking for a New Product" },
  },
  contact_us_complaint: {
    label: "Complaint / Service Issue",
    fields: [
      { key: "full_name", label: "Full Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "product_category", label: "Product Category", type: "category" },
      { key: "product_model", label: "Product Model No.", type: "text", placeholder: "Type your product model" },
      { key: "serial_number", label: "Serial Number", type: "text" },
      { key: "order_number", label: "Order / Invoice Number", type: "text" },
      { key: "purchase_date", label: "Date of Purchase", type: "date" },
      { key: "message", label: "Issue Details", type: "textarea", required: true },
    ],
    hidden: { enquiry_type: "Complaint / Service Issue" },
  },
  contact_us_general: {
    label: "General Enquiry",
    fields: [
      { key: "full_name", label: "Full Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "message", label: "Message", type: "textarea", required: true },
    ],
    hidden: { enquiry_type: "General Enquiry" },
  },
  contact_us_feedback: {
    label: "Suggestion / Feedback",
    fields: [
      { key: "full_name", label: "Full Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "message", label: "Your Suggestion / Feedback", type: "textarea", required: true },
    ],
    hidden: { enquiry_type: "Suggestion / Feedback" },
  },
  bulk_procurement: {
    label: "Bulk Procurement",
    fields: [
      { key: "organisation_name", label: "Organisation / Institution Name", type: "text", required: true },
      { key: "institution_type", label: "Type of Institution", type: "select", options: INSTITUTION_TYPES, required: true },
      { key: "contact_person", label: "Contact Person Name", type: "text", required: true },
      { key: "designation", label: "Designation", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "products_required", label: "Products Required", type: "text", required: true, placeholder: "e.g., Wheelchairs, Hospital Beds, Walkers" },
      { key: "estimated_quantity", label: "Estimated Quantity", type: "number", required: true },
      { key: "required_by", label: "Required By Date", type: "date" },
      { key: "gst_number", label: "GST Number", type: "text" },
      { key: "tender_reference", label: "Tender Reference Number", type: "text" },
      { key: "additional_requirements", label: "Additional Requirements", type: "textarea" },
    ],
  },
  csr: {
    label: "CSR Connect",
    fields: [
      { key: "organisation_name", label: "Organisation Name", type: "text", required: true },
      { key: "contact_person", label: "CSR Contact Person Name", type: "text", required: true },
      { key: "designation", label: "Designation", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "website", label: "Organisation Website", type: "url" },
      { key: "partnership_type", label: "Type of Partnership", type: "select", options: PARTNERSHIP_TYPES, required: true },
      { key: "beneficiary_details", label: "Beneficiary Details", type: "textarea", required: true },
      { key: "preferred_geography", label: "Preferred Geography / Location", type: "text", required: true },
      { key: "message", label: "Message", type: "textarea" },
    ],
  },
  dealership: {
    label: "Become Our Dealer",
    fields: [
      { key: "full_name", label: "Full Name", type: "text", required: true },
      { key: "business_name", label: "Business / Firm Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address", type: "email", required: true },
      { key: "city_state", label: "State", type: "state", required: true },
      { key: "years_in_business", label: "Years in Business", type: "number", required: true },
      { key: "current_business_type", label: "Current Business Type", type: "select", options: BUSINESS_TYPES, required: true },
      { key: "currently_sells", label: "Currently sell medical / mobility equipment?", type: "select", options: ["Yes", "No"], required: true },
      { key: "current_brands", label: "Brands currently dealing in", type: "text" },
      { key: "gst_number", label: "GST Number", type: "text", required: true },
      { key: "shop_area_sqft", label: "Shop / Showroom Area (sq. ft.)", type: "number" },
      { key: "investment_capacity", label: "Investment Capacity", type: "select", options: INVESTMENT_RANGES },
      { key: "nearest_city", label: "Nearest City / Town of Operation", type: "text", required: true },
      { key: "message", label: "Message / Additional Info", type: "textarea" },
    ],
  },
  warranty: {
    label: "Product Registration",
    fields: [
      { key: "product_category", label: "Product Category", type: "category", required: true },
      { key: "product_model", label: "Product Model", type: "text", required: true, placeholder: "Type your product model" },
      { key: "serial_number", label: "Serial Number", type: "text", required: true, placeholder: "HEM-XXXX-XXXX" },
      { key: "purchase_date", label: "Date of Purchase", type: "date", required: true },
      { key: "invoice_number", label: "Invoice / Bill Number", type: "text" },
      { key: "full_name", label: "Customer Full Name", type: "text", required: true },
      { key: "phone", label: "Mobile Number", type: "tel", required: true },
      { key: "email", label: "Email Address (for warranty certificate)", type: "email", required: true },
      { key: "dealer", label: "Dealer / Store Purchased From", type: "text" },
    ],
  },
};
